
<script>
import { Line } from "vue-chartjs";
import {
  getStyle,
  hexToRgba
} from "@coreui/coreui-pro/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { random } from "@/shared/utils";
import moment, { months } from 'moment';
import 'moment-timezone';

export default {
  components: {
    hexToRgba,
    CustomTooltips
  },
  extends: Line,
  props: ["height"],
  data(){
      return {
                today: null,
                // labels:[],
                // dataChart:[],
                datas: [
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578473990',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        '1578543917',
                        ]
            }
  },
  methods: {
      getChartData:function(num,time,data){
        let unit = num.value-1;
        let format = time.format;
        let show = time.value;
        
        let userTimezone = 'Asia/Bangkok';
        let datas = this.datas;
        let labels = [];
        let dataChart = [];

         for (let i = unit; i >= 0; i--) {
             let count = moment().tz(userTimezone).subtract(i, show).format(format);
             var number = 0;
             for(var j = 0; j < datas.length; j++) {
                 let eventTimeStamp =  moment(moment.unix(datas[j])).tz(userTimezone).format(format);
                 if (eventTimeStamp==count) {
                       number++
                }
             }
             labels.push(count);
             dataChart.push(number);
        }
        this.chart(labels,dataChart);
      },
    chart:function(labels,dataChart){
    const brandInfo = "#0B4C67";
     this.renderChart(
      {
          labels: labels,
        datasets: [
          {
            label: "user unit",
            backgroundColor: hexToRgba(brandInfo, 10),
            borderColor: "#0B4C67",
            pointHoverBackgroundColor: "#fff",
            borderWidth: 2,
            data: dataChart
          },
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: "index",
          position: "nearest",
          callbacks: {
            labelColor: function(tooltipItem, chart) {
              return {
                backgroundColor:
                  chart.data.datasets[tooltipItem.datasetIndex].borderColor
              };
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(250 / 5),
                max: 250
              },
              gridLines: {
                display: true
              }
            }
          ]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    );
      }
  }
};
</script>
